<style>
    .track-container {
        background: #fff;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 30px;
        padding: 20px;
        height: auto;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-content: flex-start;
        align-items: center;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
        border: 0;
        min-width: 220px;
        width: 200px;
        cursor: pointer;
        text-decoration: none;
    }
    .t-container-img {
        width: 200px;
        height: 100px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    .t-container-name {
        font-family: Gotham Pro, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 15px;
        color: #404455;
        margin-top: 13px;
        margin-bottom: 6px;

    }
    .t-container-size, .t-container-area {
        font-family: Gotham Pro, sans-serif;
        font-style: normal;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        color: #404455;
        margin-bottom: 0px;
    }
    .t-container-area sup {
        line-height: 0px;
    }
    .t-container-next{
        width: 133px;
        height: 38px;
        border: 1px solid #FF0000;
        box-sizing: border-box;
        border-radius: 5px;
        display: flex;
        text-align: center;
        justify-content: center;
        align-content: flex-start;
        align-items: center;
        background: #fff;
        font-size: 16px;
        line-height: 15px;
        font-family: Gotham Pro, sans-serif;
        font-style: normal;
        font-weight: bold;
        color: #FF0000;
        margin-top: 11px;
        transition: 0.25s;
    }
    button:hover .t-container-next {
        background-color: #FF0000;
        color: #FFFFFF;
    }
    button:active .t-container-next, button:focus .t-container-next {
        background-color: #FF0000;
        color: #FFFFFF;
        box-shadow: 0 0 0 0.2rem #ff000060;
    }
</style>
<script>
    import { createEventDispatcher } from 'svelte';
    export let track
    const dispatch = createEventDispatcher();

    function click(track) {
        dispatch('clickOnTrack', {
            track
        });
    }
    function getImagePrev(url) {
        if (url) {
            return "background-image: url("+url+");"
        }
        return ""
    }
</script>
<a href="#step2" on:click="{() => click(track)}" class="track-container">
    <div class="t-container-img" style="{getImagePrev(track.prev_image)}"/>
    <div class="t-container-name">Модель {track.name}</div>
    <div class="t-container-size">Размер: {track.length}*{track.width}*{track.height}</div>
    <div class="t-container-area">Площадь: {track.square} м<sup>2</sup></div>
    <div class="t-container-next">Выбрать</div>
</a>
